// Lyaout =============================================================
import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const italic: SugarElementInfo = { name: "italic", availableChildren: { type: AvailableChildrenType.Any } };
